<template>
  <header class="general">
    <div class="content clear">
      <div class="heading">
        <h1>iFootage competition entries</h1>
        <p>Here you are able to view all of the competition entries and vote for your favourite video.</p>
        <p>Feeling inspired? Why not enter your own video</p>
        <router-link to="/" class="button">Join the competition</router-link>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  name: 'Header'
}
</script>

<style lang="scss" scoped>
header.general .heading {
  max-width: unset;
  width: 100%;
}
</style>
